"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var BaseNotificationService = /** @class */ (function () {
    function BaseNotificationService() {
        this.notifications = new Map();
    }
    BaseNotificationService.prototype.add = function (notification, scope) {
        var key = scope || (0, uniqueId_1.default)();
        this.notifications.set(key, notification);
        return key;
    };
    BaseNotificationService.prototype.remove = function (key) {
        this.notifications.delete(key);
    };
    return BaseNotificationService;
}());
exports.default = BaseNotificationService;
